/* eslint-disable @typescript-eslint/no-explicit-any */
import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../../rules';
import { WhenCondition } from '../../conditions';
import { ConditionRule } from 'lib/reviews/types';
import { RuleConditionData } from '../../serialization';
import { RulesConstants } from 'lib/constants/rules';

export const PageAffiliateConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.PageAffiliate.ItemId;

export class PageAffiliateCondition<T extends RuleContext> extends WhenCondition<T> {
  pageAffiliateId: string;
  constructor(condition: RuleConditionData) {
    super();
    //@ts-ignore allow for extra condition properties
    this.pageAffiliateId = condition.pageAffiliateId;
  }

  execute(ruleContext: T): boolean {
    const conditions: Array<ConditionRule> =
      (ruleContext.parameters[RulesConstants.Parameters.Conditions] as Array<ConditionRule>) ?? [];
    conditions.push({
      propertyName: 'affiliateId',
      comparison: 'equals',
      value: Number(this.pageAffiliateId),
    });
    ruleContext.parameters[RulesConstants.Parameters.Conditions] = conditions;
    return ruleContext.parameters[RulesConstants.Parameters.Operator] ==
      RulesConstants.Operators.And
      ? true
      : false;
  }
}
